import * as React from "react"
const SvgHorizontalSpacing = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3 20V4q0-.424.288-.712A.97.97 0 0 1 4 3a.97.97 0 0 1 .713.288A.97.97 0 0 1 5 4v16a.97.97 0 0 1-.287.712A.97.97 0 0 1 4 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20m16 0V4q0-.424.288-.712A.97.97 0 0 1 20 3q.424 0 .712.288A.97.97 0 0 1 21 4v16q0 .424-.288.712A.97.97 0 0 1 20 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 19 20m-7-7a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 12q0-.424.287-.713A.97.97 0 0 1 12 11q.424 0 .713.287.287.288.287.713c0 .425-.096.52-.287.713A.97.97 0 0 1 12 13m-4 0a.97.97 0 0 1-.713-.287A.97.97 0 0 1 7 12q0-.424.287-.713A.97.97 0 0 1 8 11q.424 0 .713.287Q9 11.575 9 12c0 .425-.096.52-.287.713A.97.97 0 0 1 8 13m8 0a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 12q0-.424.287-.713A.97.97 0 0 1 16 11a.97.97 0 0 1 .712.287Q17 11.575 17 12c0 .425-.096.52-.288.713A.97.97 0 0 1 16 13" />
  </svg>
)
export default SvgHorizontalSpacing
